<div class="unsubscribe-container">
  <div class="unsubscribe-card">


    <div class="content" *ngIf="!requestSubmitted">
      <p class="message">We're sorry to see you go!</p>

      <div class="email-display" *ngIf="email">
        <strong>Email:</strong> {{ email }}
      </div>

      <form *ngIf="!email" [formGroup]="emailForm" class="email-form" (ngSubmit)="submitUnsubscribeRequest()">
        <div class="form-group">
          <input
            type="email"
            id="unsubscribe-email"
            formControlName="email"
            class="form-input"
            placeholder="you@example.com"
            autocomplete="email"
          />
          <label for="unsubscribe-email" class="form-label">Email</label>
          <div *ngIf="shouldShowFieldError()" class="field-error">
            {{ emailFieldError }}
          </div>
        </div>
      </form>

      <p class="info-text">
        Click the button below to submit an unsubscribe request. 
        Our admin team will process your request and remove you from our mailing list.
      </p>
      <button 
        class="unsubscribe-btn" 
        (click)="submitUnsubscribeRequest()"
        [disabled]="isProcessing || (!email && emailForm.invalid)">
        <span *ngIf="!isProcessing">Unsubscribe</span>
        <span *ngIf="isProcessing">Processing...</span>
      </button>
      <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
    </div>

    <div class="content success" *ngIf="requestSubmitted">
      <div class="success-icon">✓</div>
      <h2>Request Submitted Successfully</h2>
      <p class="success-text">
        Your unsubscribe request has been sent to our admin team. 
        You will be removed from our mailing list shortly.
      </p>
      <p class="note">
        If you continue to receive emails after 48 hours, please contact us directly.
      </p>
    </div>

    <div class="footer">
      <p>© {{ currentYear }} Restless Society. All rights reserved.</p>
    </div>
  </div>
</div>